import { DashboardService } from '../../services/dashboard.service';
import { Global } from '../global';
import { UtilityService } from '../../services/Acc_Utility.service';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from '../../services/user.service';
import { UserDetails } from '../../models/userDetails.interface';
import * as $ from 'jquery';
import { AccessKeyUser } from '../../models/access-key-user';

@Component({
  selector: 'nav-menu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.css']
})
export class NavMenuComponent implements OnInit {
  ArrLabels: any;
  labels: any = {};
  userDetails: UserDetails;
  email: string;
  userName: string;
  constructor(
    private UtilityService: UtilityService,
    private global: Global,
    private router: Router,
    private userService: UserService,
    private userDetailService: DashboardService) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });

    this.userDetailService.getUserDetails()
      .subscribe((userDetails: UserDetails) => {
        this.userDetails = userDetails;
        this.email = userDetails.email;
        this.userName = userDetails.userName;
        console.log(`user details` + this.userDetails.email);
        this.UtilityService.getAccessKeyUser(this.userDetails.id).subscribe(items => {
          this.accessKeyUserList = items as AccessKeyUser[];
          localStorage.setItem('accessKeyUser', JSON.stringify(items));
        });
      },
      error => {
        console.log(error);
        //this.notificationService.printErrorMessage(error);
      });
  }
  accessKeyUserList: AccessKeyUser[] = [];
  ngOnInit() {

    // $(document).ready(function(){
    //   $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function(event) {alert('ok');
    //     event.preventDefault(); 
    //     event.stopPropagation(); 
    //     $(this).parent().siblings().removeClass('open');
    //     $(this).parent().toggleClass('open');
    //   });
    // });

    //this.userDetailService.getUserDetails()
    //.subscribe((userDetails: UserDetails) => {
    //  this.userDetails = userDetails;
    //},
    //error => {
    //    console.log(error);
    //  //this.notificationService.printErrorMessage(error);
    //});

    this.getLabels();   
  }
  

  checkAccessUser(urlValue: string) {
    if (this.userName != undefined) {
      if (this.userName.toLowerCase() != "admin@admin.com") {
        let value = this.accessKeyUserList.filter(f => f.accessKeyUrl == urlValue);
        if (value.length != 0)
          return "block";
        else
          return "none";
      } else {
        return "block";
      }
    }
  }

  checkAccessUserParentMenu(urlValue: string[]) {
    let valueUrl = "none";
    if (this.userName != undefined) {
      for (var i = 0; i < urlValue.length; i++) {
        if (this.userName.toLowerCase() != "admin@admin.com") {
          let value = this.accessKeyUserList.filter(f => f.accessKeyUrl == urlValue[i]);
          if (value.length != 0)
            valueUrl = "block";
          else
            valueUrl = "none";
        } else {
          valueUrl = "block";
        }
        if (valueUrl === "block")
          return valueUrl;
      }
    }
    return valueUrl;
  }

  getLabels() {
    this.UtilityService.getLabels('navmenu', this.global.lang)
      .subscribe(response => {
        if (response) {
          this.ArrLabels = response;
          this.setLabels();
        }
      },
        error => console.log(error))
  }

  setLabels() {

    this.labels['navmenu-Title'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-Title').value;
    this.labels['navmenu-Accounts'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-Accounts').value;
    this.labels['navmenu-JournalEntry'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-JournalEntry').value;
    this.labels['navmenu-student-invoice'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-student-invoice').value;
    this.labels['navmenu-student-invoice-clear'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-student-invoice-clear').value;
    this.labels['navmenu-invoice-list'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-invoice-list').value;
    //this.labels['navmenu-student-discount-list'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-student-discount-list').value;
    this.labels['navmenu-expense-list'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-expense-list').value;
    this.labels['navmenu-expense-entry'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-expense-entry').value;
    this.labels['navmenu-income-entry'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-income-entry').value;
    this.labels['navmenu-TrialBalance'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-TrialBalance').value;
    this.labels['navmenu-IncomeStatement'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-IncomeStatement').value;
    this.labels['navmenu-balanceSheet'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-balanceSheet').value;
    this.labels['navmenu-FixAssetInitBalance'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-FixAssetInitBalance').value;
    this.labels['navmenu-account-mapping'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-account-mapping').value;
    this.labels['navmenu-import-students'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-import-students').value;
    this.labels['navmenu-change-password'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-change-password').value;
    this.labels['navmenu-reports'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-reports').value;
    this.labels['navmenu-settings'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-settings').value;
    this.labels['navmenu-logout'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-logout').value;
    //this.labels['navmenu-cards'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-cards').value;
    //this.labels['navmenu-cardsMenuLabel'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-cardsMenuLabel').value;
    //this.labels['navmenu-cardNew'] = this.ArrLabels.find((o: any) => o.key === 'navmenu-cardNew').value;
  }
  setLanDari() {
    this.global.lang = 'fa';
    this.getLabels();
    this.router.navigate(['/home/da']);
  }
  setLanEn() {
    this.global.lang = 'en';
    this.getLabels();
    this.router.navigate(['/home/en']);
  }

  logout() {
    this.userService.logout();
    console.log('loggin out...');
    this.router.navigate(['/login']);
  }

}




// WEBPACK FOOTER //
// ./src/app/components/navmenu/navmenu.component.ts